export const Chips = ({ id, options, value = [], onChange, error }) => (
  <div className="flex flex-wrap gap-2" role="group" aria-labelledby={`${id}-label`} data-testid={`chips-${id}`}>
    {options.map((o) => {
      const on = value.includes(o);
      return (
        <button key={o} type="button" aria-pressed={on} onClick={() => onChange(on ? value.filter((x) => x !== o) : [...value, o])}
          className={`px-3 py-2 text-sm border transition-colors ${on ? "border-[#0055FF] bg-[#0055FF]/15 text-white" : "border-[#27272A] text-zinc-400 hover:border-zinc-500 hover:text-white"} ${error ? "!border-[#FF3B30]/60" : ""}`}
          data-testid={`chip-${id}-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
          {o}
        </button>
      );
    })}
  </div>
);
